import React, { Component } from 'react';
import { Field } from 'redux-form';
import SelectInput from './SelectInput';

export default class Select extends Component {
  render() {
    const { name, options, suffix, selected, hideError, ...attributes } = this.props;
    return (
      <Field
        name={name}
        component={SelectInput}
        options={options}
        suffix={suffix}
        hideError={hideError}
        selected={selected}
        {...attributes}
      />
    );
  }
}
